module.exports = __webpack_public_path__ + "static/media/first-fond.6097aeb1.jpg";